require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.6@core-js/library/fn/is-iterable.js
// module id = 459
// module chunks = 0 1